/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="86.88"
        height="73.27"
        viewBox="0 0 86.88 73.27"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M63.61 0c12.87 0 23.28 11.79 23.28 26.22 0 11.38-7.1 22.45-19 32.85a114.31 114.31 0 0 1-13.19 10c-.61.4-1.21.78-1.8 1.15l-1.15.71-1.1.67-.8.47-.51.29-.66.38-.69.38a1.24 1.24 0 0 1-1.18 0l-.87-.48-1-.54-.8-.48-.86-.51q-3.66-2.24-7.69-5.09a89.73 89.73 0 0 1-18.82-17.58 1.26 1.26 0 0 1 2-1.53 87.85 87.85 0 0 0 18.39 17c2.31 1.65 4.58 3.15 6.74 4.49l1.13.69 1.17.7.52.3.75.43.94-.53.51-.3c1.38-.81 2.88-1.74 4.48-2.78a112.2 112.2 0 0 0 12.89-9.75c11.36-10 18.1-20.48 18.1-31 0-13.11-9.36-23.72-20.78-23.72a19.56 19.56 0 0 0-15.21 7.6 1.23 1.23 0 0 1-1.74.2 1.26 1.26 0 0 1-.2-.2 19.55 19.55 0 0 0-15.18-7.55C19.86 2.49 10.5 13.1 10.5 26.21a26.89 26.89 0 0 0 1.44 8.53 1.25 1.25 0 0 1-2.37.79A29.36 29.36 0 0 1 8 26.24C8 11.81 18.4.02 31.28.02a21.81 21.81 0 0 1 16 7.14l.19.21.2-.21A21.88 21.88 0 0 1 63.21.02Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M35.99 23.44a1.26 1.26 0 0 1 1.6-.76 1.24 1.24 0 0 1 .7.63v.13l10.52 28.92 7.18-11.47a1.27 1.27 0 0 1 .92-.57h14a1.25 1.25 0 0 1 .13 2.49H57.75l-8.18 13a1.24 1.24 0 0 1-1.71.43 1.17 1.17 0 0 1-.47-.49v-.13L37.17 27.56l-5.14 14.42a1.26 1.26 0 0 1-1 .82H1.31A1.24 1.24 0 0 1 0 41.62a1.25 1.25 0 0 1 1.18-1.32h28.79Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'HeartWithPulseOximeterWaveIcon';

export default Icon;
